var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"bg-gray",attrs:{"lg":"7"}},[_c('b-carousel',{staticClass:"h-100 carousel-fade",attrs:{"id":"carousel1","indicators":"","interval":"5000"}},_vm._l((_vm.images),function(imgSrcSet){return _c('b-carousel-slide',{key:imgSrcSet,staticClass:"h-100"},[_c('tzzz-image',{staticClass:"d-block h-100 w-100",staticStyle:{"object-fit":"cover"},attrs:{"slot":"img","image":imgSrcSet,"sizes":[
          '100vw',
          '(min-width: 768px) 58vw',
          '(min-width: 2200px) 1284px'
        ]},slot:"img"})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }